import type { CompareQuoteFormInput } from 'app/home/create-quote/forms/compare/compare.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';

export function compareQuoteFormSelector(store: QuoteDraftSelectorState): CompareQuoteFormInput {
  const selectedPackage = store.selectedPackage();
  return { selectedPackage };
}
